import { InternalApiClient } from '@fourthwall/services/dist/InternalApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useGetCampaignQuery = createQueryHook(InternalApiClient.getCampaign, {
  queryKey: ['campaign'],
})
